<template>
  <div>
    <Report
      module="Estoque"
      name="Produtos por Cliente"
      urlGet="/api/v1/stock/report/product-customer"
      :header="header"
      :filters="filters"
    />
  </div>
</template>

<script>
import Report from "@nixweb/nixloc-ui/src/component/report/Report";

export default {
  name: "ReportProductByCustomerView",
  components: {
    Report,
  },
  data() {
    return {
      header: [
        {
          title: "Nº Locação",
          field: "numberRent",
          fieldOrderBy: "NumberRent",
          show: true,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Cliente",
          field: "customerName",
          fieldOrderBy: "CustomerName",
          show: true,
          styleHeader: "width:250px;",
          styleBody:
            "max-width: 240px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Tipo",
          field: "typeName",
          fieldOrderBy: "TypeName",
          show: false,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Produto",
          field: "productName",
          fieldOrderBy: "ProductName",
          show: true,
          initialOrderBy: true,
          styleHeader: "width:300px;",
          styleBody:
            "max-width: 290px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Categoria",
          field: "categoryProductName",
          fieldOrderBy: "CategoryProductName",
          show: false,
          styleHeader: "width:160px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Fabricante",
          field: "manufacturerName",
          fieldOrderBy: "ManufacturerName",
          show: true,
          styleHeader: "width:160px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Unid. Medida",
          field: "unitOfMeasurementName",
          fieldOrderBy: "UnitOfMeasurementName",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Patrimoniado",
          field: "allowWithoutPatrimonyName",
          fieldOrderBy: "AllowWithoutPatrimonyName",
          show: false,
          styleHeader: "width:110px;",
          styleBody: "max-width: 100px;",
        },
        {
          title: "Status",
          field: "statusName",
          fieldOrderBy: "StatusName",
          show: true,
          styleHeader: "width:80px;",
          styleBody: "max-width: 70px;",
        },
        {
          title: "Estoque",
          field: "totalStock",
          fieldOrderBy: "TotalStock",
          show: false,
          styleHeader: "width:80px;",
          styleBody: "max-width: 70px;",
        },
        {
          title: "Reservado",
          field: "totalReserved",
          fieldOrderBy: "TotalReserved",
          show: true,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Locado",
          field: "totalRented",
          fieldOrderBy: "TotalRented",
          show: true,
          styleHeader: "width:80px;",
          styleBody: "max-width: 70px;",
        },
        {
          title: "Devolvido",
          field: "totalReturned",
          fieldOrderBy: "TotalReturned",
          show: true,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Vl. Reposição",
          field: "replacementValue",
          fieldOrderBy: "ReplacementValue",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Total Reposição",
          field: "totalReplacementValue",
          fieldOrderBy: "TotalReplacementValue",
          show: false,
          styleHeader: "width:130px;",
          styleBody: "max-width: 120px;",
        },
      ],
      filters: [
        {
          type: "text",
          title: "Nº Locação",
          field: "NumberRent",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Cliente",
          field: "CustomerName",
          url: "/api/v1/crm/customer/select-all-without-document",
          propsParams: { isCustomer: true, isSupplier: false },
          value: "",
        },
        {
          type: "options",
          title: "Tipo",
          field: "TypeName",
          options: [
            { text: "Equipamento", value: "Equipamento" },
            { text: "Acessório", value: "Acessório" },
            { text: "Material", value: "Material" },
            { text: "Serviço", value: "Serviço" },
          ],
          value: [],
        },
        {
          type: "multiOptions",
          title: "Tipo de Produto",
          field: "TypeProductName",
          url: "/api/v1/stock/type-product/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Produto",
          field: "ProductName",
          url: "/api/v1/stock/product/select-all-with-typeProduct",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Categoria",
          field: "CategoryProductName",
          url: "/api/v1/stock/category-product/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Fabricante",
          field: "ManufacturerName",
          url: "/api/v1/stock/manufacturer/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Unid. Medida",
          field: "UnitOfMeasurementName",
          url: "/api/v1/stock/unit-of-measurement/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "options",
          title: "Patrimoniado",
          field: "AllowWithoutPatrimonyName",
          options: [
            { text: "Sim", value: "Sim" },
            { text: "Não", value: "Não" },
          ],
          value: [],
        },
        {
          type: "options",
          title: "Status",
          field: "StatusName",
          options: [
            { text: "Ativo", value: "Ativo" },
            { text: "Inativo", value: "Inativo" },
          ],
          value: [],
        },
        /*   {
          type: "number",
          title: "Estoque",
          field: "TotalStock",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Reservado",
          field: "TotalReserved",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Locado",
          field: "TotalRented",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Devolvido",
          field: "TotalReturned",
          valueStart: 0,
          valueEnd: 0,
        },*/
        {
          type: "decimal",
          title: "Vl. Reposição",
          field: "ReplacementValue",
          valueStart: 0,
          valueEnd: 0,
        },
        {
          type: "decimal",
          title: "Total Reposição",
          field: "TotalReplacementValue",
          valueStart: 0,
          valueEnd: 0,
        },
      ],
    };
  },
};
</script>
        fields: [
          {
            field: "numberRent",
            title: "Nº Locacão",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: true,
            requiredOData: false,
          },
          {
            field: "customerName",
            title: "Cliente",
            type: "text",
            selected: true,
            requiredOData: false,
            styleHeader: "width:200px;",
            styleBody: "max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
          },
          {
            field: "typeName",
            title: "Tipo",
            type: "text",
            selected: false,
            requiredOData: true,
          },
          {
            field: "productName",
            title: "Produto",
            type: "text",
            orderBy: "asc",
            selected: true,
            requiredOData: false,
          },
          {
            field: "categoryProductName",
            title: "Categoria",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: false,
            requiredOData: false,
          },
          {
            field: "manufacturerName",
            title: "Fabricante",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: true,
            requiredOData: false,
          },
          {
            field: "barCode",
            title: "Codigo Grupo",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: false,
            requiredOData: false,
          },
          {
            field: "unitOfMeasurementName",
            title: "Unidade Medida",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: false,
            requiredOData: false,
          },
          {
            field: "purchaseDate",
            title: "Data Compra",
            type: "date",
            requiredOData: false,
            selected: false,
            classCssTitle: "text-center",
            classCssBody: "text-center",
          },
          {
            field: "allowWithoutPatrimonyName",
            title: "Patrimôniado",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: false,
            requiredOData: false,
          },
          {
            field: "totalStock",
            title: "Estoque",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: false,
            requiredOData: false,
          },
          {
            field: "totalReserved",
            title: "Reservado",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: true,
            requiredOData: false,
          },
          {
            field: "totalRented",
            title: "Locado",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: true,
            requiredOData: false,
          },
          {
            field: "totalReturned",
            title: "Retornado",
            type: "text",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            selected: true,
            requiredOData: false,
          },
          {
            field: "statusName",
            title: "Status",
            type: "text",
            classCssTitle: "text-center",
            fieldComparison: "statusName",
            requiredOData: true,
            selected: true,
            classCssBody: "text-center",
          },
          {
            field: "replacementValue",
            title: "Reposição",
            type: "currency",
            classCssTitle: "text-center",
            requiredOData: false,
            selected: false,
            classCssBody: "text-center",
          },
          {
            field: "totalReplacementValue",
            title: "T.Reposição",
            type: "currency",
            classCssTitle: "text-center",
            requiredOData: false,
            selected: false,
            classCssBody: "text-center",
          },
        ],
        rules: [
          {
            name: "numberRent",
            title: "Nº Locação",
            icon: "fas fa-database",
            typeField: "text",
            type: "field",
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "customerId",
            title: "Cliente",
            icon: "fas fa-database",
            typeField: "select",
            type: "field",
            props: {
              url: "/api/v1/crm/customer/select-all",
            },
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "type",
            title: "Tipo",
            icon: "fas fa-database",
            typeField: "checkbox",
            type: "field",
            options: [
              { title: "Equipamento", value: 1 },
              { title: "Acessório", value: 2 },
              { title: "Serviço", value: 3 },
            ],
            notDuplicate: true,
            isRequired: false,
          },
          {
            name: "typeProductId",
            title: "Tipo de Produto",
            icon: "fas fa-database",
            typeField: "select",
            type: "field",
            props: {
              url: "/api/v1/stock/type-product/select-all",
            },
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "productName",
            title: "Produto",
            icon: "fas fa-database",
            typeField: "text",
            type: "field",
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "categoryProductId",
            title: "Categoria",
            icon: "fas fa-database",
            typeField: "select",
            type: "field",
            props: {
              url: "/api/v1/stock/category-product/select-all",
            },
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "manufacturerId",
            title: "Fabricante",
            icon: "fas fa-database",
            typeField: "select",
            type: "field",
            props: {
              url: "/api/v1/stock/manufacturer/select-all",
            },
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "barCode",
            title: "Codigo Grupo",
            icon: "fas fa-database",
            typeField: "text",
            type: "field",
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "unitOfMeasurementId",
            title: "Unidade Medida",
            icon: "fas fa-database",
            typeField: "select",
            type: "field",
            props: {
              url: "/api/v1/stock/unit-of-measurement/select-all",
            },
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "purchaseDate",
            title: "Data Compra",
            icon: "fas fa-database",
            typeField: "dateTime",
            type: "field",
            props: {
              format: "DD/MM/YYYY",
              type: "date",
              range: true,
            },
            notDuplicate: true,
            isRequired: false,
          },
          {
            name: "allowWithoutPatrimony",
            title: "Patrimôniado",
            icon: "fas fa-database",
            typeField: "checkbox",
            type: "field",
            options: [
              { title: "Sim", value: false },
              { title: "Não", value: true },
            ],
            notDuplicate: true,
            isRequired: false,
          },
          {
            name: "totalStock",
            title: "Estoque",
            icon: "fas fa-database",
            typeField: "numeric",
            type: "field",
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "totalReserved",
            title: "Reservado",
            icon: "fas fa-database",
            typeField: "numeric",
            type: "field",
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "totalRented",
            title: "Locado",
            icon: "fas fa-database",
            typeField: "numeric",
            type: "field",
            notDuplicate: false,
            isRequired: false,
          },

          {
            name: "totalAvailable",
            title: "Disponível",
            icon: "fas fa-database",
            typeField: "numeric",
            type: "field",
            notDuplicate: false,
            isRequired: false,
          },
          {
            name: "status",
            title: "Status",
            icon: "fas fa-database",
            typeField: "checkbox",
            type: "field",
            options: [
              { title: "Ativo", value: 1 },
              { title: "Inativo", value: 2 },
            ],
            notDuplicate: true,
            isRequired: false,
          },
          {
            name: [
              "totalStock",
              "totalReserved",
              "totalRented",
              "totalReplacementValue",
            ],
            title: "Totalização",
            icon: "fas fa-sigma",
            typeField: "checkbox",
            classCss: "primary",
            type: "totalization",
            options: [
              {
                title: "Total Estoque",
                value: "sum_TotalStock",
                aggregate: {
                  title: "Total Estoque",
                  value: "sumTotalStock",
                  type: "numeric",
                },
              },
              {
                title: "Total Reservado",
                value: "sum_TotalReserved",
                aggregate: {
                  title: "Total Reservado",
                  value: "sumTotalReserved",
                  type: "numeric",
                },
              },
              {
                title: "Total Locado",
                value: "sum_TotalRented",
                aggregate: {
                  title: "Total Locado",
                  value: "sumTotalRented",
                  type: "numeric",
                },
              },
              {
                title: "Total Locado x Valor Reposição",
                value: "sum_TotalReplacementValue",
                aggregate: {
                  title: "Total Locado x Valor Reposição",
                  value: "sumTotalReplacementValue",
                  type: "currency",
                },
              },
            ],
            notDuplicate: true,
            isRequired: false,
          },
        ],
      },
    };
  },
};
</script>
